export const SERVICE_FAILURE_DEFAULT_LABELS = {
  EXIT_WORKFLOW: 'Exit Workflow',
  APPLY_TAG: 'Apply Tag',
  DO_NOT_APPLY_TAG: 'Do Not Apply Tag',
};
